/**
 * Returns true when an HTML string carries no visible content.
 *
 * Rich-text editors (Quill) serialize an "empty" editor as markup such as
 * `<p><br></p>` or `<p></p>`, which is truthy but renders nothing. Treating
 * those as empty lets callers normalize them to `''` before persisting, so a
 * blank field is genuinely cleared rather than stored as an empty paragraph.
 */
export function isEmptyHtml(html: string | null | undefined): boolean {
  if (!html) return true;
  // Drop tags and common whitespace entities, then check for any real text.
  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\u00a0/g, ' ')
    .trim();
  return text.length === 0;
}
